import { render } from "./RevenueExpenseChart.vue?vue&type=template&id=48bb758c&scoped=true&ts=true"
import script from "./RevenueExpenseChart.vue?vue&type=script&lang=ts"
export * from "./RevenueExpenseChart.vue?vue&type=script&lang=ts"

import "./RevenueExpenseChart.vue?vue&type=style&index=0&id=48bb758c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bb758c"]])

export default __exports__